export const projectData = [
  {
    id: 1,
    title: "Brain Tumor Classification using Spatiospatial Deep Learning",
    description: "Explores classifying 3D volumetric MRI scans using spatiotemporal models (ResNet(2+1)D, ResNet3D) traditionally applied to video analysis.",
    tags: ["Deep Learning", "PyTorch", "Medical AI"],
    github: "https://github.com/Harshvardhan2164/Brain-Tumor-Classification-using-Spatiospatial-Model.git",
    category: "ml",
  },
  {
    id: 2,
    title: "Genomic Sequence Prediction - Fusion Models",
    description: "N-Gram, LSTM, and Transformer-based models for DNA sequence prediction with perplexity evaluation for bioinformatics.",
    tags: ["NLP", "Transformers", "Bioinformatics"],
    github: "https://github.com/Harshvardhan2164/Power-of-Generative-AI-in-Genomics",
    category: "ml",
  },
  {
    id: 3,
    title: "LessGo - Go Backend Projects",
    description: "Go-based projects: Load Balancer, Letterboxd clone, Redis URL Shortener, and Real-time Chat Application.",
    tags: ["Go", "Redis", "Backend"],
    github: "https://github.com/Harshvardhan2164/LessGo",
    category: "fullstack",
  },
  {
    id: 4,
    title: "Applicant Tracking System",
    description: "NLP-powered ATS with semantic resume matching, scoring, and a full stack web interface for HR workflows.",
    tags: ["NLP", "ML", "React", "Flask"],
    github: "https://github.com/Harshvardhan2164/Applicant-Tracking-System-Minor-Project",
    category: "ml",
  },
  {
    id: 5,
    title: "Social Media Sentiment Analysis",
    description: "ML model for sentiment analysis on Twitter, YouTube, and Amazon with real-time data processing.",
    tags: ["ML", "Python", "NLP"],
    github: "https://github.com/Harshvardhan2164/Social-Media-Sentiment-Analysis-Minor-Project",
    category: "ml",
  },
  {
    id: 6,
    title: "Multi Agent Reinforcement Learning",
    description: "MARL techniques for cooperative hunting scenarios using game theory to optimize multi-agent strategies.",
    tags: ["RL", "Game Theory", "Python"],
    github: "https://github.com/Harshvardhan2164/Game-Theory-Project",
    category: "ml",
  },
  {
    id: 7,
    title: "Blockchain Supply Chain Management",
    description: "Decentralized supply chain system using Solidity, Node.js, MongoDB, and React for medicine tracking.",
    tags: ["Blockchain", "Solidity", "MERN"],
    github: "https://github.com/Harshvardhan2164/Supply-Chain-Management-using-Blockchain-Technology",
    category: "fullstack",
  },
  {
    id: 8,
    title: "HomeCraft - IKEA-Inspired E-Commerce",
    description: "Full-featured eCommerce app with wishlist, cart, checkout, and admin dashboard built with MERN stack.",
    tags: ["MERN", "E-Commerce", "React"],
    github: "https://github.com/Harshvardhan2164/Spargen-Assignment",
    category: "fullstack",
  },
  {
    id: 9,
    title: "AI Content Generator",
    description: "Web application for generating, editing, and managing content using AI with a modern React frontend.",
    tags: ["AI", "React", "Node.js"],
    github: "https://github.com/Harshvardhan2164/AI-Content-Generator",
    category: "fullstack",
  },
  {
    id: 10,
    title: "ERP System for MSE & MSME",
    description: "Full-stack ERP system managing inventory, sales, HR, accounting, inquiries, and quotations.",
    tags: ["Full Stack", "ERP", "React"],
    github: "https://github.com/Harshvardhan2164/ERP-System-for-MSE-and-MSME",
    category: "fullstack",
  },
  {
    id: 11,
    title: "Time Series Energy Consumption Prediction",
    description: "LSTM and GRU models for energy consumption forecasting using PJM Interconnection data.",
    tags: ["LSTM", "GRU", "Time Series"],
    github: "https://github.com/Harshvardhan2164/Time-Series-Analysis-on-Energy-Consumption",
    category: "ml",
  },
  {
    id: 12,
    title: "End-to-End MLOps Pipeline",
    description: "MLOps pipeline for wine quality prediction using MLflow for experiment tracking and model management.",
    tags: ["MLOps", "MLflow", "Python"],
    github: "https://github.com/Harshvardhan2164/MLOPS-Project",
    category: "ml",
  },
  {
    id: 13,
    title: "Social Media Post Generator",
    description: "AI tool using Llama-3.3 from Groq Cloud to generate posts matching specific writing styles.",
    tags: ["LLM", "Groq", "Python"],
    github: "https://github.com/Harshvardhan2164/Social-Media-Post-Generator-Tool",
    category: "ml",
  },
  {
    id: 14,
    title: "Weatherio: Real-Time Weather App",
    description: "Weather app with current conditions, hourly updates, sunrise/sunset times, and 5-day forecast via OpenWeather API.",
    tags: ["JavaScript", "API", "CSS"],
    github: "https://github.com/Harshvardhan2164/Weatherio-Real-Time-Weather-App",
    category: "fullstack",
  },
  {
    id: 15,
    title: "Data Science Projects - Streamlit",
    description: "Collection of interactive data science projects using Streamlit for web app visualizations and analyses.",
    tags: ["Streamlit", "Python", "Data Science"],
    github: "https://github.com/Harshvardhan2164/Data-Science-Projects-using-Streamlit",
    category: "ml",
  },
  {
    id: 16,
    title: "House Price Prediction Model",
    description: "ML model for house price prediction using EDA, data visualization, and Linear Regression.",
    tags: ["ML", "EDA", "Regression"],
    github: "https://github.com/Harshvardhan2164/House-Price-Prediction",
    category: "ml",
  },
];